export default {
  title: 'AUTO PACKAGE FOR RUNS SETTINGS',
  items: {
    RunAutopackageEnabled: {
      label: 'Enable Auto-package Runs',
      type: 'boolean',
    },
    RunAutopackageEtaOffsetSecs: {
      label: 'Run Auto Package ETA Offset Seconds',
      type: 'integer',
      unit: 'seconds'
    },
    RunAutopackageIgnoreLicense: {
      label: 'Run Auto Package Ignore License',
      type: 'boolean',
    },
    RunAutopackageRunLimit: {
      label: 'Run Auto Package Run Limit',
      type: 'integer',
      unit: ''
    },
    RunAutopackageRunDurationLimit: {
      label: 'Run Auto Package Run Duration Limit',
      type: 'integer',
      unit: 'seconds'
    },
    RunAutopackageMaxTNCRuns: {
      label: 'Run Auto Package Max TNC Runs',
      type: 'integer',
      unit: ''
    },
    RunAutopackageMaxTNCForTCP: {
      label: 'Run Auto Package Max TNC for TCP',
      type: 'integer',
      unit: ''
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/auto-package-runs.js